import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    info,
    infoMsg,
    MAX_DESCRIPTION,
    MAX_NAME,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import Select from "react-select";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {departmentService} from "../../../jwt/_services";
import {showToastCustom} from "../../../components/toast/customToast";
import {ErrorMessage, useForm} from "react-hook-form";
import * as Yup from 'yup';
import {showLoader} from "../../../components/loader/loader";
import {departmentProvider} from "../../../providers/departmentProvider";
import {employeeProvider} from "../../../providers/employeeProvider";
import {MAX_DESCRIPTION_SIZE, MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function DepartmentForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [parentDeptoOptions, setParentDeptoOptions] = useState([]);
    const [parent, setParent] = useState(editMode ? props.item?.parent : null);
    const [supervisorsOptions, setSupervisorsOptions] = useState([]);
    const [supervisors, setSupervisors] = useState(editMode ? props.item?.supervisors : []);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    useEffect(() => {
        setLoading(true);
        departmentProvider.getOptions()
            .then(result => {
                if (result) {
                    setParentDeptoOptions(result);
                    console.log(result)
                    if (props.item?.parent) {
                        departmentProvider.getItem(parent?.id)
                            .then(data => {
                                setParent(data);
                                setLoading(false);
                            });
                    }
                setLoading(false);
                }
            })
            .catch(_ => {
                setLoading(false);
            });

        setLoading(true);
        employeeProvider.getOptions()
            .then(result => {
                if (result) {
                    let supervisorsOptions = result;
                    let employeeArray = [];
                    if (supervisors) {
                        supervisors.forEach((ep) => {
                            const index = supervisorsOptions.findIndex(n => n.id === ep.id);
                            employeeArray.push(supervisorsOptions[index]);
                        });
                    }
                    setSupervisors(employeeArray);
                    setSupervisorsOptions(supervisorsOptions);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(_ => {
                setLoading(false);
            })

    }, []);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        description: Yup.string().required(REQUIRED).max(MAX_DESCRIPTION_SIZE, MAX_DESCRIPTION),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            name: savedData?.name,
            description: savedData?.description
        }
    });

    const changeSelect = (value) => {
        setParent(value);
    }

    const changeSupervisors = (value) => {
        let employee = [];

        value.forEach((item) => {
            employee.push({
                id: item.id,
                value: item.value,
                label: item.label
            });
        })
        setSupervisors(employee);
    }

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data.id,
            name: data.name,
            description: data.description,
            parent: parent,
            supervisors: supervisors
        };
        if (!editMode) {
            //Save
            return departmentService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return departmentService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setParent('');
        setSupervisors('')
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="name" name="name"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Departamento Padre</Label>
                                <Select name="parent"
                                        value={parent}
                                        options={parentDeptoOptions}
                                        placeholder="Selecciona una opción"
                                        isDisabled={disableInputs}
                                        isSearchable={true}
                                        isClearable={true}
                                        ref={register}
                                        onChange={changeSelect}/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Supervisores</Label>
                                <br/>
                                <Select
                                    isMulti
                                    name="parent"
                                    value={supervisors}
                                    options={supervisorsOptions}
                                    placeholder="Selecciona una opción"
                                    onChange={changeSupervisors}
                                    isSearchable={true}
                                    isClearable={true}
                                    isDisabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Descripción</Label>
                                <Input type="textarea" rows="5" name="description"
                                       placeholder="Ingrese una descripción"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="description" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}